export default __webpack_public_path__ + "static/media/shapeGreen.c352bd84.svg";